import { ProductResponse } from '@/types/product';

export const getProducts = async (): Promise<ProductResponse> => {
  const base = 'https://admin.uconfixings.com';
  const endpoint = 'api/public/products';
  const res = await fetch(`${base}/${endpoint}`, {
    method: 'GET',
    cache: 'force-cache',
    next: { revalidate: 60 },
  });

  if (!res.ok) {
    throw new Error(`Internal fetch to failed: ${res.statusText}`);
  }

  const data: ProductResponse = await res.json();
  if (!data.success) {
    throw new Error(`API route error: ${data}`);
  }
  return data;
};
